import { render, staticRenderFns } from "./GestioneProfili.vue?vue&type=template&id=6e8ed666&scoped=true&"
import script from "./GestioneProfili.vue?vue&type=script&lang=js&"
export * from "./GestioneProfili.vue?vue&type=script&lang=js&"
import style0 from "./GestioneProfili.vue?vue&type=style&index=0&id=6e8ed666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ed666",
  null
  
)

export default component.exports